const API_URL = "http://localhost:8000/api"; // change as needed

// Fetch imported data
export const fetchImportedData = async () => {
  const response = await fetch(`${API_URL}/data`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }

  return data;
};

export const uploadCSV = async (file, state,token) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("location", state); // ✅ FIXED (was "state")

  const response = await fetch(
    "https://app.equipmentrecovery.com/api/upload/csvUpload",
    {
     
      method: "POST",
      body: formData,
      // ❗ NO Content-Type (browser sets it automatically)
       headers: {
        Authorization: `Bearer ${token}`, // 👈 THIS IS KEY
      },
    },
 
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Upload failed");
  }

  return data;
};
